module.exports = __webpack_public_path__ + "52582e03e48978bd5a19030ca4fcc408.svg";